export default "__VITE_ASSET__0c612683__"